// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__cuj8j","checkbox":"SuperCheckbox_checkbox__GSbc6","spanClassName":"SuperCheckbox_spanClassName__Rr12W"};